<template>
  <div class="flex flex-col gap-1.5 lg:gap-2.5">
    <label :for="id" class="text-sm/[130%]">
      {{ label }}
    </label>
    <input
      :type="type"
      :name="id"
      :id="id"
      v-model="model"
      class="border-gray border p-3.75 lg:text-[17px]/[124%]"
    />
    <span v-if="error" class="animate-fade-in text-xs text-red-600">
      {{ error }}
    </span>
  </div>
</template>

<script setup lang="ts">
interface Props {
  id: string
  label: string
  type: string
  error?: string
}

defineProps<Props>()
const model = defineModel<string>()
</script>
